module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ImagesFile"
  }, [_c('div', {
    staticClass: "photo",
    on: {
      "click": function($event) {
        return _vm.imagesFiles()
      }
    }
  }, [_c('p', {
    staticClass: "add"
  }, [_vm._v("添加照片")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./../../../static/img/phone.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "add_text"
  }, [_vm._v("(最多可添加九张照片)")])]), _vm._v(" "), _c('ul', {
    staticClass: "imageShow fn-clear"
  }, _vm._l((_vm.imageList), function(item, index) {
    return _c('li', {
      key: item.id,
      on: {
        "click": function($event) {
          return _vm.removeImage(index)
        }
      }
    }, [_c('div', {
      staticClass: "images"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    })])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9ad51c8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ImagesFile.vue
// module id = 415
// module chunks = 1